// Role permission matrix — source of truth for all UI gating.
// The DB enforces these via RLS; the frontend uses them for UX only.

export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  editor:      'Editor',
  moderator:   'Moderator',
  viewer:      'Viewer',
};

export const ROLE_COLORS = {
  super_admin: { bg: '#FFF0E8', text: '#CC4A1A' },
  editor:      { bg: '#EBF5FB', text: '#2980B9' },
  moderator:   { bg: '#E8F8EF', text: '#27AE60' },
  viewer:      { bg: '#F7F5F0', text: '#6A6A6A' },
};

const MATRIX = {
  super_admin: {
    posts:      ['create', 'read', 'update', 'delete', 'publish'],
    comments:   ['read', 'update', 'delete'],
    settings:   ['read', 'update'],
    audit_logs: ['read'],
    user_roles: ['read', 'update'],
  },
  editor: {
    posts:      ['create', 'read', 'update', 'publish'],
    comments:   ['read', 'update', 'delete'],
    settings:   [],
    audit_logs: [],
    user_roles: [],
  },
  moderator: {
    posts:      ['read'],
    comments:   ['read', 'update'],
    settings:   ['read', 'update'],
    audit_logs: [],
    user_roles: [],
  },
  viewer: {
    posts:      ['read'],
    comments:   [],
    settings:   [],
    audit_logs: [],
    user_roles: [],
  },
};

export function can(role, resource, action) {
  return MATRIX[role]?.[resource]?.includes(action) ?? false;
}
